/**
 * Hook to manage Turnstile token state
 */

import { useState, useCallback } from "react";

export const useTurnstile = () => {
  const [token, setToken] = useState(null);
  const [isVerified, setIsVerified] = useState(false);
  const [error, setError] = useState(null);

  const handleVerify = useCallback((newToken) => {
    setToken(newToken);
    setIsVerified(true);
    setError(null);
  }, []);

  const handleError = useCallback(() => {
    setToken(null);
    setIsVerified(false);
    setError("Verification failed");
  }, []);

  const handleExpire = useCallback(() => {
    setToken(null);
    setIsVerified(false);
  }, []);

  const reset = useCallback(() => {
    setToken(null);
    setIsVerified(false);
    setError(null);
  }, []);

  return {
    token,
    isVerified,
    error,
    handleVerify,
    handleError,
    handleExpire,
    reset,
    // Props to spread on Turnstile component
    turnstileProps: {
      onVerify: handleVerify,
      onError: handleError,
      onExpire: handleExpire,
    },
  };
};
